import {NG_VALIDATORS, UntypedFormControl, ValidationErrors} from '@angular/forms';
import {Directive} from '@angular/core';
import {FormlyFieldConfig} from '@ngx-formly/core';

/**
 * Checks if an input element contains as a number as quantity which is a multiple of the increment.
 * Can be used like this:
 * [dcpQuantityMatchIncrement]
 */

/**
 * Custom increment validation directive that can be used to validate any input element.
 */
@Directive({
  selector: '[dcpQuantityMatchIncrement]',
  providers: [{provide: NG_VALIDATORS, useExisting: QuantityIncrementDirective, multi: true}]
})
export class QuantityIncrementDirective {
  static quantityIncrementValidator(control, field: FormlyFieldConfig) {
    const increment = field.templateOptions.step;
    let isValid: boolean = true;
    if (control && control.value && !isNaN(increment)) {
      isValid = !control.value || control.value % increment === 0;
    }
    return isValid ? null : {step: true};
  }

  validate(control: UntypedFormControl, field): ValidationErrors {
    return QuantityIncrementDirective.quantityIncrementValidator(control, field);
  }
}
